/* USERS */
export const GET_BRANCHES_OPTIONS = "GET_BRANCHES_OPTIONS";
export const GET_BRANCHES_OPTIONS_SUCCESS = "GET_BRANCHES_OPTIONS_SUCCESS";
export const GET_BRANCHES_OPTIONS_FAIL = "GET_BRANCHES_OPTIONS_FAIL";
